import { render, staticRenderFns } from "./ContractsManagement.vue?vue&type=template&id=d5588294&scoped=true"
import script from "./ContractsManagement.vue?vue&type=script&lang=js"
export * from "./ContractsManagement.vue?vue&type=script&lang=js"
import style0 from "./ContractsManagement.vue?vue&type=style&index=0&id=d5588294&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5588294",
  null
  
)

export default component.exports